import { Injectable } from '@angular/core';
import { Observable } from 'rxjs'
import { HttpService } from '@ui-components/services';
import { ICohort, IResponse } from '@interfaces/index';
import { ICreate } from 'projects/ui-components/src/interfaces/ICohort';

@Injectable({
  providedIn: 'root',
})
export class CohortService {

  constructor(
    protected _http_service: HttpService
  ) { }

  getAll(org_id: number): Observable<IResponse<ICohort[]>> {
    return this._http_service.post('cohorts/get-all', {
      org_id: org_id
    });
  };

  removeUser(cohort_id: number, user_id: number): Observable<IResponse<ICohort[]>> {
    return this._http_service.post('cohorts/remove-user', {
      cohort_id: cohort_id,
      user_id: user_id
    });
  };

  createCohort(name: string ): Observable<IResponse<ICreate>> {
    return this._http_service.post('cohorts/create', {
      name
    });
  };

  addUser(cohort_id: number, users: number[] ): Observable<IResponse<ICohort[]>> {
    return this._http_service.post('cohorts/add-users', {
      cohort_id: cohort_id,
      users
    })
  };

}